import React from "react";

const Privacy = () => {
  return (
    <div className="container my-5">
      <div className="card shadow-sm border-0">
        <div className="card-body p-4">
          <h2 className="text-center mb-4 fw-bold">Privacy Policy</h2>
          <p className="text-muted mb-4 text-center">
            Last updated: October 30, 2025
          </p>

          <h5 className="fw-semibold mt-4">1. Introduction</h5>
          <p>
            Welcome to <strong>Assit Buddi</strong>. This Privacy Policy
            explains how we collect, use, disclose, and safeguard your
            information when you use our website, mobile app, or related
            services. Please read this policy carefully to understand our views
            and practices regarding your personal data.
          </p>

          <h5 className="fw-semibold mt-4">2. Information We Collect</h5>
          <p>We may collect and process the following types of information:</p>
          <ul>
            <li>
              <strong>Personal Information:</strong> such as your name, email,
              phone number, and address.
            </li>
            <li>
              <strong>Usage Data:</strong> such as IP address, browser type,
              access time, and referring website.
            </li>
            <li>
              <strong>Cookies:</strong> small files stored on your device to
              improve user experience and website performance.
            </li>
          </ul>

          <h5 className="fw-semibold mt-4">3. How We Use Your Information</h5>
          <p>Your information may be used for the following purposes:</p>
          <ul>
            <li>To provide and manage our services.</li>
            <li>To improve user experience and website functionality.</li>
            <li>To communicate with you regarding updates or offers.</li>
            <li>To comply with legal obligations.</li>
          </ul>

          <h5 className="fw-semibold mt-4">4. Data Sharing and Disclosure</h5>
          <p>
            We do not sell, trade, or rent users’ personal identification
            information to others. However, we may share limited information
            with trusted third-party service providers who assist in operating
            our business or servicing you, provided they agree to keep this
            information confidential.
          </p>

          <h5 className="fw-semibold mt-4">5. Data Security</h5>
          <p>
            We adopt appropriate data collection, storage, and processing
            practices and security measures to protect against unauthorized
            access, alteration, disclosure, or destruction of your personal
            information.
          </p>

          <h5 className="fw-semibold mt-4">6. Your Rights</h5>
          <p>
            You have the right to access, correct, or delete your personal data.
            You may also opt-out of receiving promotional emails at any time by
            following the unsubscribe link in the emails or contacting us
            directly.
          </p>

          <h5 className="fw-semibold mt-4">7. Changes to This Policy</h5>
          <p>
            We may update this Privacy Policy periodically to reflect changes in
            our practices or for other operational, legal, or regulatory
            reasons. Please review this page occasionally to stay informed.
          </p>

          <h5 className="fw-semibold mt-4">8. Contact Us</h5>
          <p>
            If you have any questions or concerns about this Privacy Policy,
            please contact us at:
          </p>
          <ul>
            <li>Email: privacy@yourcompany.com</li>
            <li>Phone: +91-XXXXXXXXXX</li>
            <li>Address: 238, Schem No. 114, Indore, MP, India</li>
          </ul>

          <p className="text-center mt-4 mb-0">
            <strong>
              Your privacy is important to us — thank you for trusting us!
            </strong>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
